export default __webpack_public_path__ + "static/media/cladding21.d201451e.jpg";